// extracted by mini-css-extract-plugin
export var currentStep = "_gs-2";
export var nodeCard = "_gs-0";
export var pathHighlighted = "_gs-1";